export default __webpack_public_path__ + "static/painful-2b8569f36440259ac6f8269f30e491bf.webp";